import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const Lessons = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">📚 Lessons</h1>
          <p className="text-muted-foreground">onboarding material, coding lessons, internal training</p>
        </div>
      </StaggeredAnimation>

      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Lessons Dashboard</CardTitle>
            <CardDescription>onboarding material, coding lessons, internal training</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">Lessons content will be displayed here...</p>
          </CardContent>
        </Card>
      </StaggeredAnimation>
    </div>
  );
};

export default Lessons;